<template>
  <div>
    <div class="info-box">
      <div class="flex-align-center">
        <span class="icon" aria-hidden="true"></span>
        <span class="text-base-semibold">Kundenbetreuung</span>
      </div>
      <p class="text-sm">
        <a href="tel:+4921127742774" class="text-lg link-color no-break">0211-2774 2774</a>
        <abbr class="text-xs super" title="Siehe Fußnote 1" aria-describedby="cs-footnote-1">1</abbr>
        oder
        <a href="tel:+491722222022" class="text-lg link-color no-break">0172 222 20 22</a>
        <abbr class="text-xs super" title="Siehe Fußnote 2" aria-describedby="cs-footnote-2">2</abbr>
      </p>
      <p class="text-sm">
        Als <span class="uppercase">Lidl</span> <span lang="en">Connect</span> Kunde nutzt du deine Inklusiveinheiten, wenn
        vorhanden. Andernfalls zahlst du in Deutschland 0,09 <abbr title="Euro">€</abbr> pro Minute.
      </p>
      <div>
        <div class="text-xs" id="cs-footnote-1">
          1. Es gilt der vom jeweiligen Anbieter ausgewiesene Preis für einen Anruf ins deutsche Festnetz.
        </div>
        <div class="text-xs" id="cs-footnote-2">
          2. Aus Fremdnetzen gilt der vom jeweiligen Anbieter ausgewiesene Preis für einen Mobilfunkanruf ins
          <abbr title="deutsch">dt.</abbr> Vodafone-Netz.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBox'
}
</script>
